// State management with LocalStorage persistence

const STATE_KEY = 'azureVMWizardState';

export const getDefaultState = () => ({
  page1: {
    environment: 'production',
    region: 'eastus',
    vmSize: 'Standard_B2s'
  },
  page2: {
    function: '',
    purpose: '',
    instance: '01',
    adminUser: 'vmadmin'
  },
  page3: {
    subscription: '',
    objectId: '',
    resourceGroup: '',
    vnetName: '',
    vnetRG: '',
    subnetName: ''
  },
  currentPage: 1,
  timestamp: new Date().toISOString()
});

export const saveState = (state) => {
  try {
    const stateToSave = {
      ...state,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem(STATE_KEY, JSON.stringify(stateToSave));
    return true;
  } catch (error) {
    console.error('Failed to save state:', error);
    return false;
  }
};

export const loadState = () => {
  try {
    const saved = localStorage.getItem(STATE_KEY);
    if (saved) {
      const state = JSON.parse(saved);
      // Merge with defaults in case structure changed
      return { ...getDefaultState(), ...state };
    }
  } catch (error) {
    console.error('Failed to load state:', error);
  }
  return getDefaultState();
};

export const clearState = () => {
  try {
    localStorage.removeItem(STATE_KEY);
    return true;
  } catch (error) {
    console.error('Failed to clear state:', error);
    return false;
  }
};

export const updatePage = (pageKey, data) => {
  const currentState = loadState();
  const updatedState = {
    ...currentState,
    [pageKey]: {
      ...currentState[pageKey],
      ...data
    }
  };
  saveState(updatedState);
  return updatedState;
};
